export interface IAppGlobalState {
  isHost?: boolean;
  envFrom?: string;
  beURL?: string;
}

const state: IAppGlobalState = {
  isHost: undefined,
  envFrom: undefined,
  beURL: undefined,
};

export const AppGlobalStore = {
  setIsHost(value?: boolean) {
    state.isHost = value;
  },
  setEnvFrom(value?: string) {
    state.envFrom = value;
  },
  setBeURL(value?: string) {
    state.beURL = value;
  },
  getIsHost(): boolean | undefined {
    return state.isHost;
  },
  getEnvFrom(): string | undefined {
    return state.envFrom;
  },
  getBeURL(): string | undefined {
    return state.beURL;
  },
    getState(): IAppGlobalState {
    return { ...state };
  },
  setState(partial: Partial<IAppGlobalState>) {
    if (Object.prototype.hasOwnProperty.call(partial, "isHost")) state.isHost = partial.isHost;
    if (Object.prototype.hasOwnProperty.call(partial, "envFrom")) state.envFrom = partial.envFrom;
    if (Object.prototype.hasOwnProperty.call(partial, "beURL")) state.beURL = partial.beURL;
  },
};

export const setIsHost = AppGlobalStore.setIsHost;
export const setEnvFrom = AppGlobalStore.setEnvFrom;
export const getIsHost = AppGlobalStore.getIsHost;
export const getEnvFrom = AppGlobalStore.getEnvFrom;
export const getBeURL = AppGlobalStore.getBeURL;
export const setBeURL = AppGlobalStore.setBeURL;